import * as links from '../util/links.js';
import { canView } from '../util/permissions.js';
import { NAVIGATION } from './universal_header.js';

export const BASE_LINKS = [
    {
        name: NAVIGATION.CLIENTS,
        link: links.clients,
        isVisible(user) {
            return canView(NAVIGATION.CLIENTS, user);
        },
    },
    {
        name: NAVIGATION.PORTAL,
        link: links.portalLink,
        isBeta: true,
        openInNewTab: true,
        isVisible(user) {
            return canView(NAVIGATION.PORTAL, user);
        },
    },
    {
        name: NAVIGATION.CONSOLE,
        link: links.consoleLink,
        isVisible(user) {
            return canView(NAVIGATION.CONSOLE, user);
        },
    },
    {
        name: NAVIGATION.USERS,
        link: links.users,
        isVisible() {
            return true;
        },
    },
    {
        name: NAVIGATION.ANALYTICS,
        link: links.analytics,
        isVisible(user) {
            return canView(NAVIGATION.ANALYTICS, user);
        },
    },
];

export const USER_LINKS = [ {
    name: NAVIGATION.MY_PROFILE,
    key: NAVIGATION.MY_PROFILE,
    href: links.userProfile,
}, {
    name: NAVIGATION.CHANGE_PASSWORD,
    key: NAVIGATION.CHANGE_PASSWORD,
    href: links.changePassword,
}, {
    name: NAVIGATION.SWITCH_SITES,
    key: NAVIGATION.SWITCH_SITES,
    href: links.switchSites,
    shouldTestVisibility: true,
}, {
    name: NAVIGATION.SITE_SETTINGS,
    key: NAVIGATION.SITE_SETTINGS,
    href: links.siteSettings,
    shouldTestVisibility: true,
}, {
    name: NAVIGATION.LOG_OUT,
    key: NAVIGATION.LOG_OUT,
    href: links.logout,
} ];
